import { QpPromiseThrottle } from "./qp-promise-throttle.factory";
import { QpThrottle } from "./qp-throttle.factory";

let module_name = "qp-throttle";

angular.module(module_name, [])
    .factory('$qpPromiseThrottle', ["$timeout", "$q", QpPromiseThrottle])
    .factory('$qpThrottle', ["$timeout", "$q", QpThrottle]);
export { module_name }
